import classNames from 'classnames'
import * as React from 'react'

import Button from '~/components/button'
import Icon from '~/components/icon'

import { Header } from './styles'

import type { Glyphs, FontAwesomeStyles } from '~/components/icon'

type CardHeaderProps = {
  children: React.ReactNode
  className?: string
  style?: object
  separator?: boolean
}

export default function CardHeader({
  children,
  className,
  separator,
  style,
}: CardHeaderProps) {
  return (
    <Header
      className={classNames('amp-card-header', className, {
        'with-separator': separator,
      })}
      style={style}
    >
      {children}
    </Header>
  )
}

type CardTitleProps = {
  children: React.ReactNode
  className?: string
  style?: object
}

export function CardTitle({ children, className, style }: CardTitleProps) {
  return (
    <h3 className={classNames('amp-card-title', className)} style={style}>
      {children}
    </h3>
  )
}

type CardActionProps = {
  children?: React.ReactNode
  className?: string
  glyph?: Glyphs
  iconStyle?: FontAwesomeStyles
  onClick?: () => void
  style?: object
  to?: string
  title?: string
}

export function CardAction({
  children,
  className,
  glyph,
  iconStyle,
  onClick,
  style,
  to,
  title,
}: CardActionProps) {
  return (
    <Button
      className={classNames('amp-card-action', className)}
      onClick={onClick}
      style={style}
      to={to}
      type="plain"
      title={title}
    >
      {glyph && (
        <Icon iconStyle={iconStyle} glyph={glyph} className="amp-card-icon" />
      )}
      {children}
    </Button>
  )
}
